/* Progressive tools for 3D browsing and existing product photographs. */
(function () {
  'use strict';

  var mountedBrowse = new WeakSet();
  var mountedGallery = new WeakSet();

  function mountBrowse(root) {
    if (mountedBrowse.has(root)) return;
    var buttons = Array.from(root.querySelectorAll('button[data-three-filter]'));
    var cards = Array.from(root.querySelectorAll('[data-three-kind]'));
    var count = root.querySelector('[data-three-count]');
    var group = root.querySelector('[data-three-filters]') || (buttons[0] && buttons[0].parentElement);
    if (!buttons.length || !cards.length || !group) return;

    function applyFilter(selected) {
      var visible = 0;
      cards.forEach(function (card) {
        card.hidden = selected !== 'all' && card.dataset.threeKind !== selected;
        if (!card.hidden) visible++;
      });
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.threeFilter === selected));
      });
      if (count) count.textContent = visible + ' designs';
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var selected = button.dataset.threeFilter;
        /* 2026-09-21：筛选口径从「产品线」改成「基础款 / 场合主题」。
           这个白名单不同步的话，新按钮点了会被静默吞掉，一点反应都没有。 */
        if (selected === 'all' || selected === 'base' || selected === 'theme') {
          applyFilter(selected);
        }
      });
    });
    applyFilter('all');
    mountedBrowse.add(root);
    buttons.forEach(function (button) { button.hidden = false; });
    group.hidden = false;
    if (count) count.hidden = false;
  }

  function mountGallery(gallery) {
    if (mountedGallery.has(gallery) || gallery.closest('[data-gallery-design="3"]')) return;
    var trigger = gallery.querySelector('button[data-three-zoom]');
    var primary = gallery.querySelector('[data-edition-image]');
    if (!trigger || !primary) return;
    var dialog = document.createElement('dialog');
    if (typeof dialog.showModal !== 'function' || typeof dialog.close !== 'function') return;

    dialog.className = 'three-image-dialog';
    dialog.setAttribute('aria-label', 'Enlarged product image');
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'three-image-dialog__close';
    close.textContent = 'Close image';
    var figure = document.createElement('figure');
    var image = document.createElement('img');
    image.decoding = 'async';
    var caption = document.createElement('figcaption');
    figure.append(image, caption);
    dialog.append(close, figure);
    var host = gallery.closest('article') || gallery;
    host.append(dialog);

    trigger.addEventListener('click', function () {
      var current = gallery.querySelector('[data-edition-image]');
      if (!current || !(current.currentSrc || current.getAttribute('src'))) return;
      image.src = current.currentSrc || current.src;
      image.alt = current.alt || 'Product image';
      var currentCaption = gallery.querySelector('[data-edition-caption-output]');
      caption.textContent = currentCaption ? currentCaption.textContent : '';
      caption.hidden = !caption.textContent.trim();
      if (!dialog.open) dialog.showModal();
      close.focus();
    });
    close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', function () {
      if (trigger.isConnected) trigger.focus();
    });
    mountedGallery.add(gallery);
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.hidden = false;
  }

  function mount() {
    document.querySelectorAll('main [data-three-browse]').forEach(mountBrowse);
    document.querySelectorAll('main [data-edition-gallery]').forEach(mountGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
  window.addEventListener('pageshow', mount);
})();
